module.exports = __webpack_public_path__ + "media/images/slider_h1_sp_03-0556296e4215ebe498f64ddc46564f61.png";